(function () {
  'use strict';

  var root = document.getElementById('ctc-tunnel');
  if (!root) {
    // Si le tunnel n'est pas charge sur cette page, ne rien faire.
    // Le bouton CTA garde son href par defaut vers /pages/customise-ton-clavier.
    return;
  }

  // i18n helper : charge le JSON injecte cote serveur dans #ctc-tunnel-i18n.
  // Si absent (degradation), on tombe sur les valeurs FR par defaut via fallback.
  var CTC_I18N = (function () {
    var el = document.getElementById('ctc-tunnel-i18n');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  })();
  function t(key, vars) {
    var s = CTC_I18N[key];
    if (s == null) s = key;
    if (vars) {
      Object.keys(vars).forEach(function (k) {
        s = s.split('{' + k + '}').join(vars[k]);
      });
    }
    return s;
  }

  var isInline = root.getAttribute('data-inline') === 'true';
  var hiddenSections = [];
  var scrollAnchor = null;

  function openInlineTunnel(triggerEl, preselectedPersona) {
    if (!isInline) return false;
    scrollAnchor = triggerEl ? triggerEl.closest('.shopify-section') || triggerEl : null;
    var tunnelSection = root.closest('.shopify-section');
    var mainWrapper = document.querySelector('#MainContent, main, [role="main"]');
    var allSections;
    if (mainWrapper) {
      allSections = Array.from(mainWrapper.querySelectorAll(':scope > .shopify-section'));
    } else {
      var parent = tunnelSection ? tunnelSection.parentElement : null;
      allSections = parent ? Array.from(parent.children).filter(function (n) { return n.classList && n.classList.contains('shopify-section'); }) : [];
    }
    hiddenSections = allSections.filter(function (s) { return s !== tunnelSection; });
    hiddenSections.forEach(function (s) {
      s.dataset.ctcWasDisplay = s.style.display || '';
      s.style.display = 'none';
    });
    root.classList.remove('ctc-tunnel--hidden');
    if (tunnelSection) tunnelSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    document.body.classList.add('ctc-tunnel-inline-open');

    // Masquer le cookie banner Shopify s'il est present (conflit z-index)
    var cookieSelectors = [
      '[class*="shopify-pc__banner"]',
      '[class*="cookie-consent"]',
      '[class*="cookies-modal"]',
      '[id*="cookie-banner"]',
      '[class*="gdpr-consent"]'
    ].join(',');
    document.querySelectorAll(cookieSelectors).forEach(function(b) {
      if (window.getComputedStyle(b).display !== 'none') {
        b.dataset.ctcWasHidden = '1';
        b.style.setProperty('display', 'none', 'important');
      }
    });

    track('open_tunnel', { persona: preselectedPersona || null, source: 'home_cta' });

    // Si un persona est pre-selectionne via data-persona, on saute l'etape 0
    if (preselectedPersona && PERSONA_FLOW[preselectedPersona]) {
      state.persona = preselectedPersona;
      state.size = null;
      state.layout = null;
      state.switchType = null;
      state.history = ['persona'];
      var firstStep = PERSONA_FLOW[preselectedPersona][0];
      renderScreen(firstStep);
    }
    return true;
  }

  function closeInlineTunnel() {
    if (!isInline) return;
    root.classList.add('ctc-tunnel--hidden');
    hiddenSections.forEach(function (s) {
      s.style.display = s.dataset.ctcWasDisplay || '';
      delete s.dataset.ctcWasDisplay;
    });
    hiddenSections = [];
    document.body.classList.remove('ctc-tunnel-inline-open');

    // Restaurer le cookie banner masque
    document.querySelectorAll('[data-ctc-was-hidden="1"]').forEach(function(b) {
      b.style.removeProperty('display');
      delete b.dataset.ctcWasHidden;
    });
    if (scrollAnchor && scrollAnchor.scrollIntoView) {
      scrollAnchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    scrollAnchor = null;
    // Reset complet du state pour la prochaine ouverture (inclut hotswap/profileFilter/editMode,
    // sinon pollution entre deux ouvertures inline sur la home).
    state = { persona: null, budget: null, size: null, layout: null, hotswap: null, switchType: null, profileFilter: null, materialFilter: null, editMode: false, history: ['persona'] };
    renderScreen('persona');
  }

  // Bouton CTA de la home : si tunnel inline present, intercepter
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-ctc-open-tunnel]');
    if (!trigger) return;
    if (!isInline) return;
    e.preventDefault();
    var preselected = trigger.getAttribute('data-persona') || null;
    openInlineTunnel(trigger, preselected);
  });

  var state = {
    persona: null,
    budget: null,
    size: null,
    layout: null,
    hotswap: null,
    switchType: null,
    history: ['persona']
  };

  var HOTSWAP_LABEL = {
    'yes': t('hotswap_label_yes'),
    'no': t('hotswap_label_no'),
    'any': t('hotswap_label_any')
  };

  var SWITCH_COLLECTION = {
    'linear': 'switch-clavier-mecanique',
    'tactile': 'switch-clavier-mecanique',
    'clicky': 'switch-clavier-mecanique',
    'he': 'switch-magnetique',
    'any': 'switch-clavier-mecanique'
  };

  var SIZE_LABEL = {
    '40': t('size_label_40'),
    '60': t('size_label_60'),
    '65': t('size_label_65'),
    '75': t('size_label_75'),
    'tkl': t('size_label_tkl'),
    '96': t('size_label_96'),
    '100': t('size_label_100'),
    'any': t('size_label_any')
  };

  var LAYOUT_LABEL = {
    'azerty': t('layout_label_azerty'),
    'qwerty': t('layout_label_qwerty'),
    'qwertz': t('layout_label_qwertz'),
    'any': t('layout_label_any')
  };

  var SWITCH_LABEL = {
    'linear': t('switch_label_linear'),
    'tactile': t('switch_label_tactile'),
    'clicky': t('switch_label_clicky'),
    'he': t('switch_label_he'),
    'any': t('switch_label_any')
  };

  var BUDGET_LABEL = {
    '100': t('budget_label_100'),
    '150': t('budget_label_150'),
    '200': t('budget_label_200'),
    'plus': t('budget_label_plus'),
    'any': t('budget_label_any')
  };

  // Kit : pas de question hotswap car 99% des kits modernes sont hotswap par construction.
  // DIY : on garde hotswap car on peut acheter un PCB soudé séparément.
  var PERSONA_FLOW = {
    'keycaps': ['size', 'layout', 'results-keycaps', 'keycaps-done'],
    'kit': ['budget', 'size', 'layout', 'results-kit', 'kit-switches', 'kit-keycaps', 'kit-done'],
    'diy': ['budget', 'size', 'layout', 'hotswap', 'switch', 'results-diy', 'diy-done']
  };

  // Libelles adaptes au contexte du persona (a-t-il un clavier ou veut-il en construire un)
  // Les ecrans 'hotswap' n'ont pas de copy persona-dependant car le message est universel.
  var SCREEN_COPY = {
    'size': {
      'keycaps': { title: t('screen_size_keycaps_title'), sub: t('screen_size_keycaps_sub_html') },
      'kit':     { title: t('screen_size_kit_title'),     sub: t('screen_size_kit_sub_html') },
      'diy':     { title: t('screen_size_diy_title'),     sub: t('screen_size_diy_sub_html') }
    },
    'layout': {
      'keycaps': { title: t('screen_layout_keycaps_title'), sub: t('screen_layout_keycaps_sub') },
      'kit':     { title: t('screen_layout_kit_title'),     sub: t('screen_layout_kit_sub') },
      'diy':     { title: t('screen_layout_diy_title'),     sub: t('screen_layout_diy_sub') }
    }
  };

  function applyPersonaCopy(screenId) {
    if (!state.persona) return;
    var copy = SCREEN_COPY[screenId] && SCREEN_COPY[screenId][state.persona];
    if (!copy) return;
    var titleEl = screenRoot.querySelector('.ctc-tunnel__title');
    var subEl = screenRoot.querySelector('.ctc-tunnel__subtitle');
    if (titleEl) titleEl.innerHTML = copy.title;
    if (subEl) subEl.innerHTML = copy.sub;
  }

  var screenRoot = root.querySelector('[data-screen-root]');
  var progressBar = root.querySelector('.ctc-tunnel__progress-bar');
  var backBtn = root.querySelector('[data-action="back"]');
  var personaScreenHtml = screenRoot.innerHTML;

  function updateProgress() {
    if (!progressBar) return;
    var flow = PERSONA_FLOW[state.persona] || [];
    var current = state.history[state.history.length - 1];
    if (current === 'persona') {
      progressBar.style.width = '0%';
      return;
    }
    var idx = flow.indexOf(current);
    var total = flow.length;
    var pct = total > 0 ? Math.round(((idx + 1) / (total + 1)) * 100) : 0;
    progressBar.style.width = pct + '%';
  }

  function showBackButton(show) {
    if (!backBtn) return;
    if (show) backBtn.removeAttribute('hidden');
    else backBtn.setAttribute('hidden', '');
  }

  function renderScreen(screenId) {
    var current = state.history[state.history.length - 1];
    if (current !== screenId) state.history.push(screenId);

    showBackButton(state.history.length > 1);
    updateProgress();
    track('view_screen', { screen: screenId, persona: state.persona });

    if (screenId === 'persona') {
      screenRoot.innerHTML = personaScreenHtml;
      focusScreenHeading();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    screenRoot.innerHTML = '';

    var templateId = 'ctc-screen-' + screenId;
    var template = document.getElementById(templateId);
    // Les ecrans "done" partagent le meme template (kit-done), le titre est ajuste apres
    if (!template && (screenId === 'keycaps-done' || screenId === 'diy-done')) {
      template = document.getElementById('ctc-screen-kit-done');
    }
    if (!template) {
      console.error('CTC tunnel: template manquant', templateId);
      return;
    }
    screenRoot.appendChild(template.content.cloneNode(true));

    // Adapter les libelles selon le persona courant (size + layout)
    applyPersonaCopy(screenId);

    if (screenId === 'results-keycaps') loadKeycapsResults();
    else if (screenId === 'results-kit') loadKitResults();
    else if (screenId === 'results-diy') loadDiyResults();
    else if (screenId === 'kit-switches') loadKitSwitchesStep();
    else if (screenId === 'kit-keycaps') loadKitKeycapsStep();
    else if (screenId === 'kit-done') loadKitDoneStep();
    else if (screenId === 'keycaps-done') loadDoneRecap(t('done_title_keycaps'));
    else if (screenId === 'diy-done') loadDoneRecap(t('done_title_diy'));

    focusScreenHeading();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // a11y : place le focus sur le titre du nouvel ecran pour annoncer le changement
  // d'etape aux lecteurs d'ecran (preventScroll pour ne pas casser le scrollTo qui suit).
  function focusScreenHeading() {
    var heading = screenRoot.querySelector('h1, h2');
    if (!heading) return;
    heading.setAttribute('tabindex', '-1');
    try { heading.focus({ preventScroll: true }); } catch (e) { heading.focus(); }
  }

  // Mapping persona -> écran de résultats principal (pas l'écran "done" final)
  var PERSONA_RESULTS_SCREEN = {
    'keycaps': 'results-keycaps',
    'kit': 'results-kit',
    'diy': 'results-diy'
  };

  function nextScreen() {
    var flow = PERSONA_FLOW[state.persona];
    if (!flow) return;
    var current = state.history[state.history.length - 1];

    // Si on est en mode edit et tous les criteres sont remplis, sauter à l'écran résultats principal
    // (pas l'écran "done" qui est le dernier du flow)
    if (state.editMode && isAllCriteriaFilled()) {
      state.editMode = false;
      var resultsScreen = PERSONA_RESULTS_SCREEN[state.persona] || flow[flow.length - 1];
      renderScreen(resultsScreen);
      return;
    }

    if (current === 'persona') {
      renderScreen(flow[0]);
      return;
    }
    var idx = flow.indexOf(current);
    if (idx >= 0 && idx < flow.length - 1) {
      renderScreen(flow[idx + 1]);
    }
  }

  function goBack() {
    if (state.history.length <= 1) return;
    state.history.pop();
    var prev = state.history[state.history.length - 1];
    state.history.pop();
    renderScreen(prev);
  }

  function restart() {
    track('restart', { persona: state.persona });
    // Reset complet du state (incluant hotswap, profileFilter, editMode, switchType)
    state = {
      persona: null,
      budget: null,
      size: null,
      layout: null,
      hotswap: null,
      switchType: null,
      profileFilter: null,
      materialFilter: null,
      editMode: false,
      history: ['persona']
    };
    renderScreen('persona');
  }

  // Cache mémoire des listes de collection (cle = URL). Une meme collection est
  // demandee plusieurs fois dans un parcours (keycaps en results + kit-keycaps + DIY,
  // 6 collections tapis au recap...). On memorise la Promise pour dedupliquer les
  // appels concurrents et eviter les refetch. Les listes ne sont jamais mutees par
  // les appelants (filter/slice creent de nouveaux tableaux), le partage est donc sur.
  var PRODUCTS_CACHE = {};

  function fetchProducts(handle, opts) {
    opts = opts || {};
    var limit = opts.fetchLimit || 50;
    // Tri par best-seller par defaut : les produits les plus vendus de la collection
    // remontent en premier (utile pour la confiance utilisateur + filtre en stock).
    var sortBy = opts.sortBy || 'best-selling';
    var url = '/collections/' + handle + '/products.json?limit=' + limit + '&sort_by=' + encodeURIComponent(sortBy);
    if (PRODUCTS_CACHE[url]) return PRODUCTS_CACHE[url];
    var promise = fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status + ' for ' + url);
        return r.json();
      })
      .then(function (data) {
        return (data && data.products) ? data.products : [];
      })
      .catch(function (err) {
        console.warn('CTC tunnel: fetch failed', handle, err);
        delete PRODUCTS_CACHE[url]; // ne pas figer un echec en cache : autoriser un retry
        return [];
      });
    PRODUCTS_CACHE[url] = promise;
    return promise;
  }

  function bodyHtmlAsText(product) {
    if (!product || !product.body_html) return '';
    var tmp = document.createElement('div');
    tmp.innerHTML = product.body_html;
    return (tmp.textContent || tmp.innerText || '').toLowerCase();
  }

  function productHaystack(product) {
    return ((product.title || '') + ' ' + (product.tags || '') + ' ' + bodyHtmlAsText(product)).toLowerCase();
  }

  function productInStock(product) {
    if (!product.variants || product.variants.length === 0) return false;
    return product.variants.some(function (v) { return v.available !== false; });
  }

  function productMatchesSize(product, size) {
    if (!size || size === 'any') return true;
    // Le titre + tags ont le plus de poids. La description est utilisée en signal secondaire.
    var titleTags = ((product.title || '') + ' ' + (product.tags || '')).toLowerCase();
    var fullHay = productHaystack(product);
    // Patterns elargis pour capter les conventions de nommage CTC :
    // - 60% : GH60, GH61, BM60, 61 keys
    // - 65% : GH64, 64 ANSI/ISO (66 keys)
    // - 75% : YZ75, ID75
    // - TKL : XD87, 87 keys
    var patterns = {
      '40': ['40%', '40 keys', '40-key'],
      '60': ['60%', 'gh60', 'gh61', '61%', '61 keys', '61-key', 'bm60', ' 60 '],
      '65': ['65%', '64 ansi', '64 iso', 'gh64', '66 keys', '66-key'],
      '75': ['75%', 'id75', 'yz75', '84 keys', '84-key'],
      'tkl': ['tkl', '80%', ' 87 ', '87 keys', '87-key', 'xd87', '88 keys', '89 keys'],
      '96': ['96%', '98%', '100 keys', '99 keys'],
      '100': ['100%', 'fullsize', 'full size', 'pleine taille', ' 108 ', '108 keys', '104 keys']
    };
    var keys = patterns[size] || [];
    // Match prioritaire sur titre/tags
    if (keys.some(function (k) { return titleTags.indexOf(k) > -1; })) return true;
    // Sinon, accepter si la description mentionne explicitement la taille
    // (mais pas "tous formats", "tous claviers" qui sont trop generiques)
    var genericRejects = ['tous formats', 'tous claviers', 'tout type', 'all sizes', 'all keyboards'];
    if (genericRejects.some(function (g) { return fullHay.indexOf(g) > -1; })) return false;
    return keys.some(function (k) { return fullHay.indexOf(k) > -1; });
  }

  function productMatchesLayout(product, layout) {
    if (!layout || layout === 'any') return true;
    var hay = productHaystack(product);
    if (layout === 'azerty') return hay.indexOf('azerty') > -1;
    if (layout === 'qwerty') return hay.indexOf('qwerty') > -1;
    if (layout === 'qwertz') return hay.indexOf('qwertz') > -1 || hay.indexOf('iso de') > -1;
    return true;
  }

  function productMatchesHotswap(product, hotswap) {
    if (!hotswap || hotswap === 'any') return true;
    var hay = productHaystack(product);
    var hasHotswap = hay.indexOf('hot-swap') > -1 || hay.indexOf('hotswap') > -1 || hay.indexOf('hot swap') > -1;
    var hasSolder = hay.indexOf('soudé') > -1 || hay.indexOf('soude') > -1 || hay.indexOf('solder') > -1 || hay.indexOf('soudage') > -1;
    if (hotswap === 'yes') {
      // On veut explicitement hotswap : on accepte le produit s'il mentionne hotswap
      // OU s'il ne mentionne ni l'un ni l'autre (par défaut on suppose hotswap, standard moderne)
      if (hasHotswap) return true;
      if (hasSolder && !hasHotswap) return false;
      return true; // benefice du doute
    }
    if (hotswap === 'no') {
      // L'user accepte de souder : on filtre pas dur, on garde tout
      return true;
    }
    return true;
  }

  function productMatchesSwitchType(product, switchType) {
    if (!switchType || switchType === 'any') return true;
    var hay = productHaystack(product);
    var hasWord = function (w) { return hay.indexOf(w) > -1; };
    var explicitLinear = hasWord('linear') || hasWord('lineaire') || hasWord('linéaire');
    var explicitTactile = hasWord('tactile');
    var explicitClicky = hasWord('clicky');

    if (switchType === 'linear') {
      if (explicitLinear) return true;
      if (explicitTactile || explicitClicky) return false;
      return ['mx red', 'mx black', 'mx silent red', 'mx speed', ' red ', 'yellow', 'oil king', 'silent red'].some(hasWord);
    }
    if (switchType === 'tactile') {
      if (explicitTactile) return true;
      if (explicitLinear || explicitClicky) return false;
      return ['mx brown', ' brown ', 'marron', 'boba u4t', 'holy panda', 'zealio'].some(hasWord);
    }
    if (switchType === 'clicky') {
      if (explicitClicky) return true;
      if (explicitLinear || explicitTactile) return false;
      return ['mx blue', 'mx green', 'box white', 'kailh white', ' bleu '].some(hasWord);
    }
    if (switchType === 'he') {
      return ['hall', 'magnet', 'effet hall', 'magnetique', 'magnétique', 'magnetic'].some(hasWord);
    }
    return true;
  }

  // Matiere des keycaps. Mots cherches avec bornes de mot pour eviter les faux positifs
  // ('abs' ne doit pas matcher 'absorbe', 'absolu'...). PBT = durable/mat, ABS = vif/brillant.
  function productMatchesMaterial(product, material) {
    if (!material || material === 'all') return true;
    var hay = productHaystack(product);
    if (material === 'pbt') return /\bpbt\b/.test(hay);
    if (material === 'abs') return /\babs\b/.test(hay);
    return true;
  }

  // Budget : on garde les produits dont la variante la moins chere est <= au plafond.
  // 'any'/'plus' = aucun plafond. Prix en euros (chaine decimale dans products.json).
  function productMatchesBudget(product, budget) {
    if (!budget || budget === 'any' || budget === 'plus') return true;
    var max = parseFloat(budget);
    if (isNaN(max)) return true;
    var variants = product.variants || [];
    if (!variants.length) return true;
    var min = null;
    variants.forEach(function (v) {
      var p = parseFloat(v.price);
      if (!isNaN(p) && (min === null || p < min)) min = p;
    });
    return min === null ? true : min <= max;
  }

  function filterProducts(products, filters) {
    filters = filters || {};
    return products.filter(function (p) {
      if (filters.inStockOnly !== false && !productInStock(p)) return false;
      if (filters.size && !productMatchesSize(p, filters.size)) return false;
      if (filters.layout && !productMatchesLayout(p, filters.layout)) return false;
      if (filters.switchType && !productMatchesSwitchType(p, filters.switchType)) return false;
      if (filters.hotswap && !productMatchesHotswap(p, filters.hotswap)) return false;
      if (filters.material && !productMatchesMaterial(p, filters.material)) return false;
      if (filters.budget && !productMatchesBudget(p, filters.budget)) return false;
      return true;
    });
  }

  function loadFilteredProducts(handle, filters, limit, minResults) {
    // minResults : seuil en dessous duquel on bascule sur le fallback "elargir"
    var threshold = minResults != null ? minResults : (limit || 12);
    return fetchProducts(handle, { fetchLimit: 50 }).then(function (products) {
      var filtered = filterProducts(products, filters);
      var inStockAll = filterProducts(products, { inStockOnly: true });
      return {
        products: filtered.slice(0, limit || 12),
        filteredCount: filtered.length,
        fallback: filtered.length < threshold ? inStockAll.slice(0, limit || 12) : [],
        totalInStock: inStockAll.length,
        isLow: filtered.length > 0 && filtered.length < threshold,
        // Catalogue carrement vide (collection inexistante ou aucun produit en stock)
        emptyCollection: products.length === 0 || inStockAll.length === 0
      };
    });
  }

  function emptyCollectionHtml(label) {
    return (
      '<div class="ctc-tunnel__empty-category">' +
        '<strong>' + escapeHtml(t('empty_category_strong', { label: label })) + '</strong>' +
        '<p>' + t('empty_category_lead') + '</p>' +
        '<button type="button" class="ctc-tunnel__empty-cta" data-action="open-expert">' + t('empty_category_cta') + '</button>' +
      '</div>'
    );
  }

  function formatPrice(amount) {
    if (amount == null) return '';
    var n = parseFloat(amount);
    if (isNaN(n)) return '';
    return n.toFixed(2).replace('.', ',') + ' EUR';
  }

  function productCardHtml(product, index, opts) {
    opts = opts || {};
    var maxBestSellers = opts.maxBestSellers != null ? opts.maxBestSellers : 1;
    var quickMode = opts.quickMode === true;
    var img = '';
    if (product.images && product.images.length > 0) {
      img = product.images[0].src;
    } else if (product.featured_image) {
      img = product.featured_image;
    }
    var price = '';
    var variants = product.variants || [];
    if (variants.length > 0) {
      price = formatPrice(variants[0].price);
    }
    var singleVariant = variants.length === 1;
    var firstVariantId = variants[0] ? variants[0].id : '';
    var firstVariantAvailable = variants[0] ? variants[0].available !== false : true;
    var isBestSeller = index < maxBestSellers;
    // En mode "quick", la modale ouverte sera la version compacte (variant + add)
    var multiVariantAction = quickMode ? 'open-preview-quick' : 'open-preview';
    var multiVariantLabel = quickMode ? t('ajouter_choisir') : t('choisir');
    return (
      '<div class="ctc-product" data-product-handle="' + escapeHtml(product.handle) + '">' +
        (isBestSeller ? '<span class="ctc-product__badge">' + t('best_seller_badge') + '</span>' : '') +
        '<button type="button" class="ctc-product__preview-trigger" data-action="' + multiVariantAction + '" data-handle="' + escapeHtml(product.handle) + '" aria-label="' + escapeHtml(t('voir_produit')) + '">' +
          (img ? '<span class="ctc-product__img"><img loading="lazy" src="' + addImgWidth(img, 400) + '" alt="' + escapeHtml(product.title) + '"></span>' : '<span class="ctc-product__img ctc-product__img--empty"></span>') +
          '<span class="ctc-product__title">' + escapeHtml(product.title) + '</span>' +
          (price ? '<span class="ctc-product__price">' + price + '</span>' : '') +
        '</button>' +
        '<div class="ctc-product__actions">' +
          (singleVariant && firstVariantAvailable
            ? '<button type="button" class="ctc-product__add" data-action="quick-add" data-variant-id="' + firstVariantId + '" data-handle="' + escapeHtml(product.handle) + '" data-title="' + escapeHtml(product.title) + '">' + t('ajouter') + '</button>'
            : '<button type="button" class="ctc-product__add" data-action="' + multiVariantAction + '" data-handle="' + escapeHtml(product.handle) + '">' + multiVariantLabel + '</button>'
          ) +
        '</div>' +
      '</div>'
    );
  }


  function addImgWidth(src, width) {
    if (!src) return '';
    if (src.indexOf('?') > -1) return src + '&width=' + width;
    return src + '?width=' + width;
  }

  function escapeHtml(s) {
    if (!s) return '';
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Tracking analytics du tunnel. Pousse dans dataLayer (GTM) + emet un evenement DOM
  // 'ctc:tunnel' (ecoutable par tout autre script). Ne doit JAMAIS casser le parcours :
  // tout est encapsule dans un try/catch silencieux.
  function track(action, payload) {
    try {
      var data = { event: 'ctc_tunnel', ctc_action: action };
      if (payload) Object.keys(payload).forEach(function (k) { data[k] = payload[k]; });
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(data);
      document.dispatchEvent(new CustomEvent('ctc:tunnel', { detail: data }));
    } catch (e) { /* analytics non bloquant */ }
  }

  // Piege le focus clavier a l'interieur d'une modale ouverte (accessibilite).
  function ctcTrapFocus(container, e) {
    var f = container.querySelectorAll('a[href], button:not([disabled]), textarea, input:not([disabled]), select, [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      });
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  // Section(s) du theme a rafraichir apres un ajout panier (compteur header WB).
  var THEME_CART_SECTIONS = ['cart-icon-bubble'];

  // L'app de "cart drawer" patche window.fetch pour ouvrir le tiroir panier a CHAQUE
  // /cart/add.js. Dans le funnel, on veut ajouter SANS ouvrir le drawer (l'utilisateur
  // enchaine les ajouts en restant dans le tunnel, surtout en flow Kit/DIY). On recupere
  // donc un fetch "propre" depuis une iframe same-origin : c'est une autre fonction que
  // le window.fetch patche par l'app, donc l'ajout n'est pas intercepte et le drawer ne
  // s'ouvre pas. Le panier (cookie same-origin) est bien mis a jour. Fallback = window.fetch.
  var _ctcCleanFetch = null;
  function getCtcCleanFetch() {
    if (_ctcCleanFetch) return _ctcCleanFetch;
    try {
      var ifr = document.createElement('iframe');
      ifr.setAttribute('aria-hidden', 'true');
      ifr.tabIndex = -1;
      ifr.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden;left:-9999px';
      document.body.appendChild(ifr); // garde l'iframe attachee : la detacher invaliderait le contexte
      var ifw = ifr.contentWindow;
      if (ifw && typeof ifw.fetch === 'function' && ifw.fetch !== window.fetch) {
        _ctcCleanFetch = function () { return ifw.fetch.apply(ifw, arguments); };
      }
    } catch (e) { /* fallback ci-dessous */ }
    if (!_ctcCleanFetch) _ctcCleanFetch = function () { return window.fetch.apply(window, arguments); };
    return _ctcCleanFetch;
  }

  function addToCart(variantId, quantity) {
    return getCtcCleanFetch()('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: quantity || 1 }],
        sections: THEME_CART_SECTIONS,
        sections_url: window.location.pathname
      })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    }).then(function (resp) {
      syncThemeHeaderCart(resp);
      var added = resp && resp.items && resp.items[0];
      track('add_to_cart', {
        persona: state.persona,
        screen: state.history[state.history.length - 1],
        variant_id: added ? added.id : variantId,
        product_title: added ? (added.product_title || added.title) : null,
        value: added ? (added.price / 100) : null
      });
      return resp;
    });
  }

  // Le tunnel ajoutait au panier sans prevenir le theme : le compteur de l'en-tete
  // restait perime jusqu'au reload. On remplace #cart-icon-bubble a partir du HTML de
  // section retourne par l'API, puis on publie l'evenement cart-update du theme
  // (consomme par le drawer Dawn et les barres de livraison gratuite eventuelles).
  function syncThemeHeaderCart(addResponse) {
    try {
      var sections = addResponse && addResponse.sections;
      if (sections && sections['cart-icon-bubble']) {
        var parsed = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var fresh = parsed.querySelector('#cart-icon-bubble');
        var live = document.getElementById('cart-icon-bubble');
        if (fresh && live) live.outerHTML = fresh.outerHTML;
      }
      if (typeof window.publish === 'function') {
        window.publish('cart-update', { source: 'ctc-tunnel' });
      }
    } catch (e) {
      console.warn('CTC tunnel: theme header cart sync failed', e);
    }
  }

  function updateCartIndicator() {
    return getCart().then(function (cart) {
      var indicator = document.getElementById('ctc-cart-indicator');
      if (!indicator) return cart;
      var count = cart.item_count || 0;
      indicator.querySelector('[data-cart-count]').textContent = count;
      indicator.querySelector('[data-cart-total]').textContent = formatPrice(cart.total_price / 100);
      if (count > 0) indicator.removeAttribute('hidden');
      else indicator.setAttribute('hidden', '');
      return cart;
    });
  }

  function showToast(message, type) {
    var container = document.getElementById('ctc-toast-container');
    if (!container) return;
    var toast = document.createElement('div');
    toast.className = 'ctc-toast ctc-toast--' + (type || 'success');
    toast.innerHTML = '<span class="ctc-toast__msg">' + escapeHtml(message) + '</span>';
    container.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('ctc-toast--show'); });
    setTimeout(function () {
      toast.classList.remove('ctc-toast--show');
      setTimeout(function () { toast.remove(); }, 300);
    }, 3000);
  }

  function quickAdd(variantId, title, btn, componentKey) {
    if (btn) {
      btn.disabled = true;
      btn.textContent = t('added_dots');
    }
    addToCart(variantId, 1).then(function () {
      if (btn) {
        btn.textContent = t('added');
        btn.classList.add('ctc-product__add--added');
        setTimeout(function () {
          btn.textContent = t('ajouter');
          btn.classList.remove('ctc-product__add--added');
          btn.disabled = false;
        }, 1500);
      }
      showToast(t('toast_added', { title: title }), 'success');
      updateCartIndicator();
      onCartAddSuccess({ componentKey: componentKey });
    }).catch(function (err) {
      console.warn('CTC add to cart failed', err);
      if (btn) {
        btn.textContent = t('ajouter');
        btn.disabled = false;
      }
      showToast(err && err.description ? err.description : t('toast_add_error'), 'error');
    });
  }

  function openPreview(handle, componentKey, opts) {
    opts = opts || {};
    var overlay = document.createElement('div');
    overlay.className = 'ctc-modal ctc-modal--preview' + (opts.quick ? ' ctc-modal--quick' : '');
    if (componentKey) overlay.dataset.ctcComponentKey = componentKey;
    overlay.dataset.ctcQuickMode = opts.quick ? '1' : '0';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML =
      '<div class="ctc-modal__inner ctc-modal__inner--preview">' +
        '<button class="ctc-modal__close" type="button" aria-label="' + escapeHtml(t('expert_modal_close')) + '">&times;</button>' +
        '<div class="ctc-preview__body"><div class="ctc-tunnel__loading">' + t('loading_product') + '</div></div>' +
      '</div>';
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';

    var ctcPrevFocus = document.activeElement;
    function close() {
      document.removeEventListener('keydown', onKeydown);
      overlay.remove();
      document.body.style.overflow = '';
      if (ctcPrevFocus && ctcPrevFocus.focus) ctcPrevFocus.focus();
    }
    overlay.ctcClose = close;
    function onKeydown(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') ctcTrapFocus(overlay, e);
    }
    overlay.querySelector('.ctc-modal__close').addEventListener('click', close);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });
    document.addEventListener('keydown', onKeydown);
    var ctcCloseBtn = overlay.querySelector('.ctc-modal__close');
    if (ctcCloseBtn) ctcCloseBtn.focus();

    fetchProduct(handle).then(function (product) {
      renderPreview(overlay, product);
    }).catch(function (err) {
      console.warn('CTC preview failed', err);
      overlay.querySelector('.ctc-preview__body').innerHTML =
        '<p class="ctc-tunnel__empty">' + t('preview_unavailable_html', { handle: escapeHtml(handle) }) + '</p>';
    });
  }

  function renderPreview(overlay, product) {
    var body = overlay.querySelector('.ctc-preview__body');
    var isQuick = overlay.dataset.ctcQuickMode === '1';
    var images = product.images || [];
    var mainImg = images[0] || product.featured_image || '';
    var variants = product.variants || [];
    var firstVariant = variants[0] || {};
    var price = formatPrice((firstVariant.price || 0) / 100);
    var compareAt = firstVariant.compare_at_price ? formatPrice(firstVariant.compare_at_price / 100) : '';

    var optionsHtml = '';
    if (variants.length > 1 && product.options) {
      var optionsNames = product.options.map(function (o) {
        return typeof o === 'string' ? o : (o.name || '');
      });
      optionsHtml = optionsNames.map(function (name, i) {
        var values = [];
        variants.forEach(function (v) {
          var val = v['option' + (i + 1)];
          if (val && values.indexOf(val) === -1) values.push(val);
        });
        var optsSelect = values.map(function (val) {
          return '<option value="' + escapeHtml(val) + '">' + escapeHtml(val) + '</option>';
        }).join('');
        return (
          '<label class="ctc-preview__option">' +
            '<span class="ctc-preview__option-name">' + escapeHtml(name) + '</span>' +
            '<select class="ctc-preview__select" data-option-index="' + i + '">' + optsSelect + '</select>' +
          '</label>'
        );
      }).join('');
    }

    var descHtml = '';
    if (product.description) {
      // On garde le HTML d'origine (avec listes, paragraphes, disclaimers)
      // pour ne PAS tronquer un message critique style "stock 0 AZERTY".
      descHtml = product.description;
    }

    var thumbsHtml = images.length > 1
      ? '<div class="ctc-preview__thumbs">' + images.slice(0, 6).map(function (im, i) {
          return '<button type="button" class="ctc-preview__thumb' + (i === 0 ? ' is-active' : '') + '" data-thumb-index="' + i + '">' +
            '<img loading="lazy" src="' + addImgWidth(im, 100) + '" alt="">' +
          '</button>';
        }).join('') + '</div>'
      : '';

    if (isQuick) {
      body.innerHTML =
        '<div class="ctc-preview__quick">' +
          (mainImg ? '<div class="ctc-preview__quick-img"><img src="' + addImgWidth(mainImg, 240) + '" alt="' + escapeHtml(product.title) + '"></div>' : '') +
          '<div class="ctc-preview__quick-info">' +
            '<h3 class="ctc-preview__title">' + escapeHtml(product.title) + '</h3>' +
            '<p class="ctc-preview__price">' +
              '<span data-preview-price>' + price + '</span>' +
              (compareAt ? '<span class="ctc-preview__compare">' + compareAt + '</span>' : '') +
            '</p>' +
            (optionsHtml ? '<div class="ctc-preview__options">' + optionsHtml + '</div>' : '') +
            '<button type="button" class="ctc-preview__add" data-action="preview-add">' + t('add_to_cart') + '</button>' +
            '<a class="ctc-preview__full-link" href="/products/' + escapeHtml(product.handle) + '">' + t('details_link') + '</a>' +
          '</div>' +
        '</div>';
    } else {
      body.innerHTML =
        '<div class="ctc-preview__layout">' +
          '<div class="ctc-preview__media">' +
            '<div class="ctc-preview__main-img">' +
              (mainImg ? '<img id="ctc-preview-main-img" src="' + addImgWidth(mainImg, 800) + '" alt="' + escapeHtml(product.title) + '">' : '') +
            '</div>' +
            thumbsHtml +
          '</div>' +
          '<div class="ctc-preview__info">' +
            (product.vendor ? '<p class="ctc-preview__vendor">' + escapeHtml(product.vendor) + '</p>' : '') +
            '<h3 class="ctc-preview__title">' + escapeHtml(product.title) + '</h3>' +
            '<p class="ctc-preview__price">' +
              '<span data-preview-price>' + price + '</span>' +
              (compareAt ? '<span class="ctc-preview__compare">' + compareAt + '</span>' : '') +
            '</p>' +
            (descHtml ? '<div class="ctc-preview__desc">' + descHtml + '</div>' : '') +
            (optionsHtml ? '<div class="ctc-preview__options">' + optionsHtml + '</div>' : '') +
            '<button type="button" class="ctc-preview__add" data-action="preview-add">' + t('add_to_cart') + '</button>' +
            '<a class="ctc-preview__full-link" href="/products/' + escapeHtml(product.handle) + '">' + t('fiche_complete_link') + '</a>' +
          '</div>' +
        '</div>';
    }

    var state = { selectedVariant: firstVariant };

    function findVariant() {
      if (variants.length === 1) return variants[0];
      var selects = body.querySelectorAll('.ctc-preview__select');
      var chosen = [];
      selects.forEach(function (s) { chosen.push(s.value); });
      var match = variants.find(function (v) {
        for (var i = 0; i < chosen.length; i++) {
          if (v['option' + (i + 1)] !== chosen[i]) return false;
        }
        return true;
      });
      return match || variants[0];
    }

    function refreshSelected() {
      var v = findVariant();
      state.selectedVariant = v;
      var priceEl = body.querySelector('[data-preview-price]');
      if (priceEl) priceEl.textContent = formatPrice((v.price || 0) / 100);
      var addBtn = body.querySelector('[data-action="preview-add"]');
      if (addBtn) {
        if (v.available === false) {
          addBtn.textContent = t('out_of_stock');
          addBtn.disabled = true;
          addBtn.classList.add('ctc-preview__add--disabled');
        } else {
          addBtn.textContent = t('add_to_cart');
          addBtn.disabled = false;
          addBtn.classList.remove('ctc-preview__add--disabled');
        }
      }
    }

    body.querySelectorAll('.ctc-preview__select').forEach(function (s) {
      s.addEventListener('change', refreshSelected);
    });

    body.querySelectorAll('.ctc-preview__thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        var idx = parseInt(t.getAttribute('data-thumb-index'), 10);
        var newSrc = images[idx];
        if (newSrc) {
          var mainImgEl = document.getElementById('ctc-preview-main-img');
          if (mainImgEl) mainImgEl.src = addImgWidth(newSrc, 800);
          body.querySelectorAll('.ctc-preview__thumb').forEach(function (x) {
            x.classList.remove('is-active');
          });
          t.classList.add('is-active');
        }
      });
    });

    body.querySelector('[data-action="preview-add"]').addEventListener('click', function (e) {
      var btn = e.currentTarget;
      var v = state.selectedVariant;
      if (!v || v.available === false) return;
      btn.disabled = true;
      btn.textContent = t('adding');
      addToCart(v.id, 1).then(function () {
        btn.textContent = t('added_cart');
        showToast(t('toast_added', { title: product.title }), 'success');
        updateCartIndicator();
        // Pour DIY, on essaie de retrouver la categorie via le contexte d'ouverture de la modale
        var ctx = {};
        if (overlay.dataset.ctcComponentKey) ctx.componentKey = overlay.dataset.ctcComponentKey;
        setTimeout(function () {
          btn.textContent = t('add_to_cart');
          btn.disabled = false;
          var modal = btn.closest('.ctc-modal');
          if (modal && modal.ctcClose) modal.ctcClose();
          else { if (modal) modal.remove(); document.body.style.overflow = ''; }
          onCartAddSuccess(ctx);
        }, 900);
      }).catch(function (err) {
        console.warn('CTC preview add failed', err);
        btn.textContent = t('add_to_cart');
        btn.disabled = false;
        showToast(err && err.description ? err.description : t('toast_add_error'), 'error');
      });
    });

    refreshSelected();
  }

  function pickKeycapsHandle(layout) {
    if (layout === 'azerty') return 'keycaps-azerty';
    if (layout === 'qwerty') return 'keycaps-qwerty';
    if (layout === 'qwertz') return 'iso-de-keycaps';
    return 'mx-keycaps';
  }

  function pickKitsHandle() {
    return 'kit-clavier-custom';
  }

  function pickSwitchHandle(switchType) {
    return SWITCH_COLLECTION[switchType] || SWITCH_COLLECTION.any;
  }

  function fillResultsHeader(titleText, subText) {
    var titleEl = screenRoot.querySelector('[data-results-title]');
    var subEl = screenRoot.querySelector('[data-results-sub]');
    if (titleEl) titleEl.textContent = titleText;
    if (subEl) subEl.textContent = subText;
  }

  // Mapping profil -> handle collection Shopify
  var PROFILE_HANDLES = {
    'cherry': 'keycaps-cherry',
    'oem': 'keycaps-oem',
    'sa': 'keycaps-sa',
    'xda': 'keycaps-xda',
    'artisan': 'artisan-keycaps'
  };

  function filterKeycapsByProfile(profile, btnEl) {
    var chipsContainer = screenRoot.querySelector('[data-profile-chips]');
    if (chipsContainer) {
      chipsContainer.querySelectorAll('.ctc-chip').forEach(function (c) { c.classList.remove('ctc-chip--active'); });
      if (btnEl) btnEl.classList.add('ctc-chip--active');
    }
    state.profileFilter = (profile === 'all') ? null : profile;
    reloadKeycapsGrid();
  }

  function filterKeycapsByMaterial(material, btnEl) {
    var chipsContainer = screenRoot.querySelector('[data-material-chips]');
    if (chipsContainer) {
      chipsContainer.querySelectorAll('.ctc-chip').forEach(function (c) { c.classList.remove('ctc-chip--active'); });
      if (btnEl) btnEl.classList.add('ctc-chip--active');
    }
    state.materialFilter = (material === 'all') ? null : material;
    reloadKeycapsGrid();
  }

  // Re-rend la grille keycaps en combinant profil (collection) + layout + matiere (PBT/ABS).
  function reloadKeycapsGrid() {
    var grid = screenRoot.querySelector('[data-results-grid]');
    if (!grid) return;
    grid.innerHTML = '<div class="ctc-tunnel__loading">' + t('loading_products') + '</div>';
    // Profil = all : collection layout. Sinon : collection profil croisee au layout cote client.
    var targetHandle = state.profileFilter ? PROFILE_HANDLES[state.profileFilter] : pickKeycapsHandle(state.layout);
    var filters = { inStockOnly: true };
    if (state.profileFilter && state.layout) filters.layout = state.layout;
    if (state.materialFilter) filters.material = state.materialFilter;

    loadFilteredProducts(targetHandle, filters, 12, 3).then(function (res) {
      if (res.products.length > 0) {
        grid.innerHTML = res.products.map(function(p, i){ return productCardHtml(p, i, { maxBestSellers: 3 }); }).join('');
      } else if (res.fallback.length > 0) {
        grid.innerHTML =
          '<p class="ctc-tunnel__empty">' + t('no_keycaps_profile') + '</p>' +
          res.fallback.map(function(p, i){ return productCardHtml(p, i, { maxBestSellers: 3 }); }).join('');
      } else {
        grid.innerHTML = '<p class="ctc-tunnel__empty">' + t('no_keycaps_in_category') + '</p>';
      }
    });
  }

  function loadKeycapsResults() {
    // Repart d'un etat de filtres propre a chaque (re)affichage de l'ecran resultats.
    state.profileFilter = null;
    state.materialFilter = null;
    var handle = pickKeycapsHandle(state.layout);
    fillResultsHeader(
      t('keycaps_results_title', { layout: LAYOUT_LABEL[state.layout] }),
      t('keycaps_results_sub')
    );
    renderCriteriaChips(['persona', 'size', 'layout']);
    var grid = screenRoot.querySelector('[data-results-grid]');
    loadFilteredProducts(handle, { inStockOnly: true }, 12).then(function (res) {
      if (!grid) return;
      if (res.emptyCollection) {
        grid.innerHTML = emptyCollectionHtml(t('keycaps_results_title', { layout: LAYOUT_LABEL[state.layout] }));
        return;
      }
      if (res.products.length > 0) {
        grid.innerHTML = res.products.map(function(p, i){ return productCardHtml(p, i, { maxBestSellers: 3 }); }).join('');
      } else if (res.fallback.length > 0) {
        grid.innerHTML =
          '<p class="ctc-tunnel__empty">' + t('no_keycaps_profile_match_html') + '</p>' +
          res.fallback.map(function(p, i){ return productCardHtml(p, i, { maxBestSellers: 3 }); }).join('');
      } else {
        grid.innerHTML = '<p class="ctc-tunnel__empty">' + t('no_keycaps_in_stock_html', { handle: handle }) + '</p>';
      }
    });
  }

  function loadKitResults() {
    var handle = pickKitsHandle();
    fillResultsHeader(
      t('kit_results_title', { size: SIZE_LABEL[state.size] }),
      t('kit_results_sub')
    );
    renderCriteriaChips(['persona', 'budget', 'size', 'layout']);

    // Disclaimer layout : la plupart des kits du marche sont vendus en ANSI par defaut.
    // Pour AZERTY/QWERTZ, l'user doit verifier la compat ISO du PCB inclus.
    var headerArea = screenRoot.querySelector('.ctc-tunnel__subtitle');
    if (headerArea && (state.layout === 'azerty' || state.layout === 'qwertz')) {
      var existingNotice = screenRoot.querySelector('[data-kit-layout-notice]');
      if (!existingNotice) {
        var notice = document.createElement('div');
        notice.className = 'ctc-tunnel__notice ctc-tunnel__notice--iso';
        notice.setAttribute('data-kit-layout-notice', '');
        notice.innerHTML = t('kit_iso_notice_html', { layout: LAYOUT_LABEL[state.layout] });
        headerArea.parentNode.insertBefore(notice, headerArea.nextSibling);
      }
    }
    var grid = screenRoot.querySelector('[data-results-grid]');
    loadFilteredProducts(handle, { size: state.size, hotswap: state.hotswap, budget: state.budget, inStockOnly: true }, 12, 3).then(function (res) {
      if (!grid) return;
      if (res.products.length >= 3) {
        grid.innerHTML = res.products.map(function(p, i){ return productCardHtml(p, i, { maxBestSellers: 3 }); }).join('');
      } else if (res.fallback.length > 0) {
        var introMsg = res.products.length > 0
          ? '<p class="ctc-tunnel__empty">' + t('few_kits_size_html', { size: SIZE_LABEL[state.size], count: res.products.length, plural: (res.products.length > 1 ? 's' : '') }) + '</p>'
          : '<p class="ctc-tunnel__empty">' + t('no_kits_size_html', { size: SIZE_LABEL[state.size] }) + '</p>';
        grid.innerHTML = introMsg +
          res.fallback.map(function(p, i){ return productCardHtml(p, i, { maxBestSellers: 3 }); }).join('');
      } else {
        grid.innerHTML = '<p class="ctc-tunnel__empty">' + t('no_kits_html') + '</p>';
      }
    });

    var switchAddon = screenRoot.querySelector('[data-addon="switches"]');
    var keycapsAddon = screenRoot.querySelector('[data-addon="keycaps"]');
    if (switchAddon) switchAddon.setAttribute('href', '/collections/switch-clavier-mecanique');
    if (keycapsAddon) keycapsAddon.setAttribute('href', '/collections/' + pickKeycapsHandle(state.layout));
  }

  function loadDiyResults() {
    fillResultsHeader(
      t('diy_results_title', { size: SIZE_LABEL[state.size], layout: LAYOUT_LABEL[state.layout] }),
      t('diy_results_sub')
    );
    renderCriteriaChips(['persona', 'budget', 'size', 'layout', 'hotswap', 'switch']);

    var isoWarning = screenRoot.querySelector('[data-iso-warning]');
    if (isoWarning) {
      if (state.layout === 'azerty') isoWarning.removeAttribute('hidden');
      else isoWarning.setAttribute('hidden', '');
    }

    // Composants size-sensitive : case, PCB, plate. Stabs = universels.
    // IMPORTANT : ces 3 composants doivent matcher EXACTEMENT la taille du clavier.
    // Un case 60% ne se monte pas dans un PCB 65%. Donc pas de fallback "autres tailles".
    var sizeFilteredHandles = ['case-clavier-custom', 'pcb-clavier', 'plate-clavier'];
    var sizeFilteredLabels = {
      'case-clavier-custom': t('cat_label_cases'),
      'pcb-clavier': t('cat_label_pcb'),
      'plate-clavier': t('cat_label_plates')
    };
    // Un build complet exige case + PCB + plate dans la meme taille. Si l'une de ces
    // categories est vide pour la taille choisie, le build est impossible : on bascule
    // l'utilisateur vers un kit pret a monter de la meme taille (case/PCB/plate inclus)
    // plutot que de le laisser sur un dead-end.
    var structuralPromises = sizeFilteredHandles.map(function (handle) {
      var grid = screenRoot.querySelector('[data-component-grid="' + handle + '"]');
      if (!grid) return Promise.resolve(false);
      // PCB est aussi filtré sur hotswap (les autres composants ne le sont pas)
      var filters = { size: state.size, budget: state.budget, inStockOnly: true };
      if (handle === 'pcb-clavier' && state.hotswap) filters.hotswap = state.hotswap;
      // Switches Hall Effect = PCB HE obligatoire (un PCB MX ne prend PAS de switch HE).
      // On restreint donc la grille PCB aux PCB HE. UNIQUEMENT pour 'he' : appliquer
      // l'heuristique switch aux autres types exclurait a tort les PCB MX standards.
      if (handle === 'pcb-clavier' && state.switchType === 'he') filters.switchType = 'he';
      return loadFilteredProducts(handle, filters, 3, 1).then(function (res) {
        if (res.products.length > 0) {
          // On affiche les produits qui matchent la taille, meme s'il n'y en a que 1 ou 2
          grid.innerHTML = res.products.map(function(p, i){ return productCardHtml(p, i, { maxBestSellers: 1 }); }).join('');
          return false;
        }
        // Indisponible pour cette taille : note compacte (la banniere pivot gere la suite)
        var catLabel = sizeFilteredLabels[handle] || t('cat_label_plates');
        grid.innerHTML = '<p class="ctc-component__unavailable">' + t('diy_unavailable_size', { category: catLabel, size: SIZE_LABEL[state.size] }) + '</p>';
        return true;
      }).catch(function () { return true; });
    });

    Promise.all(structuralPromises).then(function (results) {
      var anyEmpty = results.some(function (x) { return x === true; });
      if (anyEmpty) injectDiyKitPivot();
    });

    // Stabs : pas de filtre taille
    var stabsGrid = screenRoot.querySelector('[data-component-grid="stabilisateur-clavier"]');
    if (stabsGrid) {
      loadFilteredProducts('stabilisateur-clavier', { budget: state.budget, inStockOnly: true }, 3, 3).then(function (res) {
        if (res.products.length >= 3) {
          stabsGrid.innerHTML = res.products.map(function(p, i){ return productCardHtml(p, i, { maxBestSellers: 1 }); }).join('');
        } else if (res.fallback.length > 0) {
          stabsGrid.innerHTML = res.fallback.map(function(p, i){ return productCardHtml(p, i, { maxBestSellers: 1 }); }).join('');
        } else {
          stabsGrid.innerHTML = '<p class="ctc-tunnel__empty">' + t('stabs_rupture_html') + '</p>';
        }
      });
    }

    var switchHandle = pickSwitchHandle(state.switchType);
    var switchesGrid = screenRoot.querySelector('[data-component-grid-dynamic="switches"]');
    var switchesMore = screenRoot.querySelector('[data-switches-more]');
    var switchesNote = screenRoot.querySelector('[data-switches-note]');
    if (switchesMore) switchesMore.setAttribute('href', '/collections/' + switchHandle);
    if (switchesNote && state.switchType && state.switchType !== 'any') {
      var hint = '';
      if (state.switchType === 'linear') hint = t('switch_hint_linear');
      else if (state.switchType === 'tactile') hint = t('switch_hint_tactile');
      else if (state.switchType === 'clicky') hint = t('switch_hint_clicky');
      else if (state.switchType === 'he') hint = t('switch_hint_he');
      switchesNote.textContent = hint;
    }
    if (switchesGrid) {
      var switchFilters = { budget: state.budget, inStockOnly: true };
      if (state.switchType && state.switchType !== 'any') switchFilters.switchType = state.switchType;
      loadFilteredProducts(switchHandle, switchFilters, 3, 3).then(function (res) {
        if (res.emptyCollection) {
          // Collection vide (typiquement switch-magnetique pas encore approvisionne)
          var label = state.switchType === 'he' ? t('switch_he_label') : t('switch_label_generic');
          switchesGrid.innerHTML = emptyCollectionHtml(label);
          return;
        }
        if (res.products.length >= 3) {
          switchesGrid.innerHTML = res.products.map(function(p, i){ return productCardHtml(p, i, { maxBestSellers: 1, quickMode: true }); }).join('');
        } else if (res.fallback.length > 0) {
          switchesGrid.innerHTML =
            '<p class="ctc-tunnel__empty ctc-tunnel__empty--small">' + t('no_switch_filtered_html', { label: (SWITCH_LABEL[state.switchType] || '') }) + '</p>' +
            res.fallback.map(function(p, i){ return productCardHtml(p, i, { maxBestSellers: 1, quickMode: true }); }).join('');
        } else {
          switchesGrid.innerHTML = '<p class="ctc-tunnel__empty">' + t('switch_rupture_html') + '</p>';
        }
      });
    }

    var keycapsHandle = pickKeycapsHandle(state.layout);
    var keycapsGrid = screenRoot.querySelector('[data-component-grid-dynamic="keycaps"]');
    var keycapsMore = screenRoot.querySelector('[data-keycaps-more]');
    if (keycapsMore) keycapsMore.setAttribute('href', '/collections/' + keycapsHandle);
    if (keycapsGrid) {
      loadFilteredProducts(keycapsHandle, { budget: state.budget, inStockOnly: true }, 3, 3).then(function (res) {
        if (res.emptyCollection) {
          // Collection vide (typiquement iso-de-keycaps pour layout QWERTZ)
          keycapsGrid.innerHTML = emptyCollectionHtml(t('keycaps_results_title', { layout: LAYOUT_LABEL[state.layout] }));
          return;
        }
        if (res.products.length >= 3) {
          keycapsGrid.innerHTML = res.products.map(function(p, i){ return productCardHtml(p, i, { maxBestSellers: 1 }); }).join('');
        } else if (res.fallback.length > 0) {
          keycapsGrid.innerHTML = res.fallback.map(function(p, i){ return productCardHtml(p, i, { maxBestSellers: 1 }); }).join('');
        } else {
          keycapsGrid.innerHTML = '<p class="ctc-tunnel__empty">' + t('no_keycaps_diy_html', { handle: keycapsHandle }) + '</p>';
        }
      });
    }
  }

  function injectDiyKitPivot() {
    if (screenRoot.querySelector('[data-diy-kit-pivot]')) return;
    var checklist = screenRoot.querySelector('[data-checklist]');
    if (!checklist) return;
    var sizeLabel = SIZE_LABEL[state.size] || '';
    var banner = document.createElement('div');
    banner.className = 'ctc-tunnel__kit-pivot';
    banner.setAttribute('data-diy-kit-pivot', '');
    banner.innerHTML =
      '<span class="ctc-tunnel__kit-pivot-icon" aria-hidden="true">&#128230;</span>' +
      '<div class="ctc-tunnel__kit-pivot-body">' +
        '<strong>' + t('diy_pivot_strong', { size: sizeLabel }) + '</strong>' +
        '<p>' + t('diy_pivot_lead', { size: sizeLabel }) + '</p>' +
      '</div>' +
      '<button type="button" class="ctc-tunnel__kit-pivot-cta" data-action="pivot-to-kit">' + t('diy_pivot_cta', { size: sizeLabel }) + '</button>';
    checklist.parentNode.insertBefore(banner, checklist);
  }

  function renderCriteriaChips(criteria) {
    var screen = screenRoot.querySelector('.ctc-tunnel__screen');
    if (!screen) return;
    var existing = screen.querySelector('.ctc-criteria-chips');
    if (existing) existing.remove();

    var chips = [];
    if (criteria.indexOf('budget') > -1 && state.budget && state.budget !== 'any') {
      chips.push({ label: t('criteria_budget', { value: BUDGET_LABEL[state.budget] }), edit: 'budget' });
    }
    if (criteria.indexOf('size') > -1 && state.size) {
      chips.push({ label: t('criteria_size', { value: SIZE_LABEL[state.size] }), edit: 'size' });
    }
    if (criteria.indexOf('layout') > -1 && state.layout) {
      chips.push({ label: t('criteria_layout', { value: LAYOUT_LABEL[state.layout] }), edit: 'layout' });
    }
    if (criteria.indexOf('hotswap') > -1 && state.hotswap) {
      chips.push({ label: t('criteria_hotswap', { value: HOTSWAP_LABEL[state.hotswap] }), edit: 'hotswap' });
    }
    if (criteria.indexOf('switch') > -1 && state.switchType) {
      chips.push({ label: t('criteria_switches', { value: (SWITCH_LABEL[state.switchType] || state.switchType) }), edit: 'switch' });
    }
    if (chips.length === 0) return;

    var container = document.createElement('div');
    container.className = 'ctc-criteria-chips';
    container.innerHTML =
      '<span class="ctc-criteria-chips__label">' + t('criteria_label') + '</span>' +
      chips.map(function (c) {
        return '<button type="button" class="ctc-criteria-chip" data-action="edit-criterion" data-criterion="' + c.edit + '">' +
          escapeHtml(c.label) +
          '<span class="ctc-criteria-chip__edit" aria-label="' + escapeHtml(t('criteria_edit_aria')) + '">&#9998;</span>' +
        '</button>';
      }).join('');

    var subtitle = screen.querySelector('.ctc-tunnel__subtitle');
    if (subtitle && subtitle.parentNode) {
      subtitle.parentNode.insertBefore(container, subtitle.nextSibling);
    } else {
      var title = screen.querySelector('.ctc-tunnel__title');
      if (title && title.parentNode) {
        title.parentNode.insertBefore(container, title.nextSibling);
      }
    }
  }

  function editCriterion(criterion) {
    // On preserve les autres choix : l'user revient sur 1 etape, change son choix,
    // et on saute directement aux resultats si tous les criteres sont remplis.
    var screenId = criterion;
    if (criterion === 'switch') screenId = 'switch';
    if (criterion === 'hotswap') screenId = 'hotswap';
    var flow = PERSONA_FLOW[state.persona] || [];
    var stepIdx = flow.indexOf(screenId);
    if (stepIdx === -1) return;
    state.editMode = true;
    state.history = ['persona'].concat(flow.slice(0, stepIdx));
    renderScreen(screenId);
  }

  function isAllCriteriaFilled() {
    if (!state.persona) return false;
    if (state.size == null) return false;
    if (state.layout == null) return false;
    // Hotswap est seulement demandé en DIY (retiré du flow kit)
    if (state.persona === 'diy' && state.hotswap == null) return false;
    if (state.persona === 'diy' && state.switchType == null) return false;
    return true;
  }

  function buildContextString() {
    var parts = [];
    if (state.persona) {
      var personaLabels = {
        keycaps: t('persona_label_keycaps'),
        kit: t('persona_label_kit'),
        diy: t('persona_label_diy')
      };
      parts.push(t('context_persona_label', { label: (personaLabels[state.persona] || state.persona) }));
    }
    if (state.budget && state.budget !== 'any') parts.push(t('context_budget_label', { label: BUDGET_LABEL[state.budget] }));
    if (state.size) parts.push(t('context_size_label', { label: SIZE_LABEL[state.size] }));
    if (state.layout) parts.push(t('context_layout_label', { label: LAYOUT_LABEL[state.layout] }));
    if (state.switchType) parts.push(t('context_switch_label', { label: (SWITCH_LABEL[state.switchType] || state.switchType) }));
    return parts.join(' | ');
  }

  function buildExpertTextareaTemplate() {
    // Construit un brouillon de message pré-rempli pour aider l'utilisateur à formuler sa demande
    // selon le contexte du tunnel. Vide si aucun critère choisi.
    var parts = [];
    if (state.persona === 'keycaps') parts.push(t('template_persona_keycaps'));
    else if (state.persona === 'kit') parts.push(t('template_persona_kit'));
    else if (state.persona === 'diy') parts.push(t('template_persona_diy'));
    else parts.push(t('template_persona_generic'));
    if (state.size && state.size !== 'any') parts.push(t('template_size', { size: SIZE_LABEL[state.size] }));
    if (state.layout && state.layout !== 'any') parts.push(state.layout === 'azerty' ? 'AZERTY ISO FR' : LAYOUT_LABEL[state.layout]);
    if (state.hotswap === 'yes') parts.push(t('template_hotswap_yes'));
    if (state.switchType && state.switchType !== 'any') {
      if (state.switchType === 'linear') parts.push(t('template_switch_linear'));
      else if (state.switchType === 'tactile') parts.push(t('template_switch_tactile'));
      else if (state.switchType === 'clicky') parts.push(t('template_switch_clicky'));
      else if (state.switchType === 'he') parts.push(t('template_switch_he'));
    }
    if (parts.length === 1) return ''; // juste persona = template peu utile
    return parts.join(' ') + t('template_tail');
  }

  function openExpertModal() {
    track('open_expert', { persona: state.persona, source: 'tunnel' });
    var context = buildContextString();
    var textareaTemplate = buildExpertTextareaTemplate();
    var overlay = document.createElement('div');
    overlay.className = 'ctc-modal ctc-modal--expert';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML =
      '<div class="ctc-modal__inner ctc-modal__inner--expert">' +
        '<button class="ctc-modal__close" type="button" aria-label="' + escapeHtml(t('expert_modal_close')) + '">&times;</button>' +
        '<div class="ctc-expert">' +
          '<span class="ctc-expert__kicker">' + t('expert_kicker') + '</span>' +
          '<h3 class="ctc-expert__title">' + t('expert_title') + '</h3>' +
          '<p class="ctc-expert__lead">' + t('expert_lead') + '</p>' +
          '<form class="ctc-expert__form" action="/contact#contact_form" method="post" accept-charset="UTF-8">' +
            '<input type="hidden" name="form_type" value="contact">' +
            '<input type="hidden" name="utf8" value="✓">' +
            (context ? '<input type="hidden" name="contact[Contexte tunnel]" value="' + escapeHtml(context) + '">' : '') +
            '<input type="hidden" name="contact[Source]" value="Tunnel Composer mon clavier">' +
            '<label class="ctc-expert__label">' +
              '<span>' + t('expert_label_email') + ' <span class="ctc-expert__req">' + t('expert_required') + '</span></span>' +
              '<input type="email" name="contact[email]" required placeholder="' + escapeHtml(t('expert_placeholder_email')) + '">' +
            '</label>' +
            '<label class="ctc-expert__label">' +
              '<span>' + t('expert_label_project') + ' <span class="ctc-expert__req">' + t('expert_required') + '</span></span>' +
              '<textarea name="contact[body]" required rows="4" placeholder="' + escapeHtml(t('expert_placeholder_project')) + '">' + escapeHtml(textareaTemplate) + '</textarea>' +
              (textareaTemplate ? '<span class="ctc-expert__hint">' + t('expert_hint') + '</span>' : '') +
            '</label>' +
            '<div class="ctc-expert__row">' +
              '<label class="ctc-expert__label">' +
                '<span>' + t('expert_label_name') + '</span>' +
                '<input type="text" name="contact[name]" placeholder="' + escapeHtml(t('expert_placeholder_name')) + '">' +
              '</label>' +
              '<label class="ctc-expert__label">' +
                '<span>' + t('expert_label_phone') + '</span>' +
                '<input type="tel" name="contact[phone]" placeholder="' + escapeHtml(t('expert_placeholder_phone')) + '">' +
              '</label>' +
            '</div>' +
            (context ? '<p class="ctc-expert__context">' + t('expert_context_html', { context: escapeHtml(context) }) + '</p>' : '') +
            '<button type="submit" class="ctc-expert__submit">' + t('expert_submit') + '</button>' +
            '<p class="ctc-expert__legal">' + t('expert_legal') + '</p>' +
          '</form>' +
        '</div>' +
      '</div>';

    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';

    var ctcPrevFocus = document.activeElement;
    function close() {
      document.removeEventListener('keydown', onKeydown);
      overlay.remove();
      document.body.style.overflow = '';
      if (ctcPrevFocus && ctcPrevFocus.focus) ctcPrevFocus.focus();
    }
    overlay.ctcClose = close;
    function onKeydown(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') ctcTrapFocus(overlay, e);
    }
    overlay.querySelector('.ctc-modal__close').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', onKeydown);
    var ctcExpertEmail = overlay.querySelector('input[name="contact[email]"]');
    if (ctcExpertEmail) ctcExpertEmail.focus();
    else { var cb = overlay.querySelector('.ctc-modal__close'); if (cb) cb.focus(); }
    var ctcExpertForm = overlay.querySelector('.ctc-expert__form');
    if (ctcExpertForm) ctcExpertForm.addEventListener('submit', function () {
      track('expert_submit', { persona: state.persona, source: 'tunnel' });
    });
  }

  function onCartAddSuccess(addContext) {
    addContext = addContext || {};
    var current = state.history[state.history.length - 1];

    // Persona kit : parcours guide en 3 etapes (kit -> switches -> keycaps -> done)
    if (state.persona === 'kit') {
      var kitFlow = PERSONA_FLOW.kit;
      var kitSteps = ['results-kit', 'kit-switches', 'kit-keycaps'];
      if (kitSteps.indexOf(current) === -1) return;
      var kIdx = kitFlow.indexOf(current);
      if (kIdx >= 0 && kIdx < kitFlow.length - 1) {
        setTimeout(function () { renderScreen(kitFlow[kIdx + 1]); }, 700);
      }
      return;
    }

    // Persona keycaps : un seul produit a ajouter, on passe direct au recap done
    if (state.persona === 'keycaps' && current === 'results-keycaps') {
      setTimeout(function () { renderScreen('keycaps-done'); }, 700);
      return;
    }

    // Persona DIY : checklist 6 categories. On coche la categorie ajoutee
    // et on rend visible le CTA "Mon clavier est complet" si pas deja affiche.
    if (state.persona === 'diy' && current === 'results-diy') {
      markDiyCategoryAdded(addContext.componentKey);
      showDiyCompleteCta();
      return;
    }
  }

  // Ordre d'achat recommandé par les experts (Switch and Click, Kinetic Labs, Thekapco)
  // : le PCB en premier car il conditionne toutes les compatibilités suivantes.
  var DIY_CATEGORY_ORDER = ['pcb', 'case', 'plate', 'stabs', 'switches', 'keycaps'];

  function markDiyCategoryAdded(componentKey) {
    if (!componentKey) return;
    var article = screenRoot.querySelector('.ctc-component[data-component="' + componentKey + '"]');
    if (article) article.classList.add('ctc-component--checked');
    // Cherche la prochaine categorie non cochee et y deploie le focus
    focusNextDiyCategory(componentKey);
  }

  function focusNextDiyCategory(currentKey) {
    var idx = DIY_CATEGORY_ORDER.indexOf(currentKey);
    if (idx === -1) idx = 0;
    var allComponents = Array.from(screenRoot.querySelectorAll('.ctc-component'));
    // Nettoyer toute precedente mise en avant
    allComponents.forEach(function (c) { c.classList.remove('ctc-component--next-up'); });

    // Cherche la prochaine non checked (en partant de l'actuelle + 1, en boucle)
    var next = null;
    for (var i = 1; i <= DIY_CATEGORY_ORDER.length; i++) {
      var candidateKey = DIY_CATEGORY_ORDER[(idx + i) % DIY_CATEGORY_ORDER.length];
      var candidate = screenRoot.querySelector('.ctc-component[data-component="' + candidateKey + '"]');
      if (candidate && !candidate.classList.contains('ctc-component--checked')) {
        next = candidate;
        break;
      }
    }

    if (next) {
      next.classList.add('ctc-component--next-up');
      setTimeout(function () {
        next.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 350);
      // L'effet pulse s'enleve apres 6s pour ne pas saturer
      setTimeout(function () {
        next.classList.remove('ctc-component--next-up');
      }, 6000);
    } else {
      // Toutes les categories sont checkees : ton clavier est complet
      revealDiyAllCheckedBanner();
    }
  }

  function revealDiyAllCheckedBanner() {
    if (screenRoot.querySelector('[data-diy-all-checked]')) return;
    var checklist = screenRoot.querySelector('[data-checklist]');
    if (!checklist) return;
    var banner = document.createElement('div');
    banner.className = 'ctc-tunnel__addons-banner';
    banner.setAttribute('data-diy-all-checked', '');
    banner.innerHTML =
      '<span class="ctc-tunnel__addons-banner-icon" aria-hidden="true">&#127881;</span>' +
      '<span class="ctc-tunnel__addons-banner-text">' + t('done_all_checked_html') + '</span>';
    checklist.parentNode.insertBefore(banner, checklist);
    banner.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function findComponentKeyForButton(btn) {
    // Remonte le DOM jusqu'a un .ctc-component pour identifier la categorie
    var article = btn.closest && btn.closest('.ctc-component');
    return article ? article.getAttribute('data-component') : null;
  }

  function showDiyCompleteCta() {
    // Le CTA n'apparait que quand TOUTES les 6 categories sont cochees.
    var checkedCount = screenRoot.querySelectorAll('.ctc-component--checked').length;
    var totalCount = DIY_CATEGORY_ORDER.length; // 6
    if (checkedCount < totalCount) return;

    var existing = screenRoot.querySelector('[data-diy-complete-cta]');
    if (existing) {
      existing.classList.add('is-visible');
      return;
    }
    var checklist = screenRoot.querySelector('[data-checklist]');
    if (!checklist) return;
    var cta = document.createElement('div');
    cta.className = 'ctc-tunnel__diy-complete is-visible';
    cta.setAttribute('data-diy-complete-cta', '');
    cta.innerHTML =
      '<button type="button" class="ctc-tunnel__diy-complete-btn" data-action="goto-diy-done">' +
        '<span>' + t('done_complete_cta') + '</span>' +
        '<span class="ctc-tunnel__diy-complete-arrow" aria-hidden="true">&rarr;</span>' +
      '</button>';
    checklist.parentNode.insertBefore(cta, checklist.nextSibling);
  }

  function loadKitSwitchesStep() {
    state.kitSwitchUsage = 'all'; // reset filter à l'entrée de l'étape
    loadKitSwitchesGrid('all');
  }

  function loadKitSwitchesGrid(usage) {
    var grid = screenRoot.querySelector('[data-results-grid]');
    if (!grid) return;
    grid.innerHTML = '<div class="ctc-tunnel__loading">' + t('loading_switches') + '</div>';
    var handle = usage === 'he' ? 'switch-magnetique' : 'switch-clavier-mecanique';
    var filters = { inStockOnly: true };
    if (usage && usage !== 'all') filters.switchType = usage;
    loadFilteredProducts(handle, filters, 12, 3).then(function (res) {
      if (res.emptyCollection) {
        var label = usage === 'he' ? t('switch_he_label') : t('switch_label_generic');
        grid.innerHTML = emptyCollectionHtml(label);
        return;
      }
      if (res.products.length >= 3) {
        grid.innerHTML = res.products.map(function(p, i){ return productCardHtml(p, i, { maxBestSellers: 3, quickMode: true }); }).join('');
      } else if (res.fallback.length > 0) {
        var msg = (usage && usage !== 'all') ? '<p class="ctc-tunnel__empty ctc-tunnel__empty--small">' + t('few_switches_kit_html') + '</p>' : '';
        grid.innerHTML = msg + res.fallback.map(function(p, i){ return productCardHtml(p, i, { maxBestSellers: 3, quickMode: true }); }).join('');
      } else {
        grid.innerHTML = '<p class="ctc-tunnel__empty">' + t('no_switches_kit_html') + '</p>';
      }
    });
  }

  function filterKitSwitchesByUsage(usage, btnEl) {
    state.kitSwitchUsage = usage;
    var chipsContainer = screenRoot.querySelector('[data-switch-usage-chips]');
    if (chipsContainer) {
      chipsContainer.querySelectorAll('.ctc-chip').forEach(function (c) { c.classList.remove('ctc-chip--active'); });
      if (btnEl) btnEl.classList.add('ctc-chip--active');
    }
    loadKitSwitchesGrid(usage);
  }

  function loadKitKeycapsStep() {
    var keycapsHandle = pickKeycapsHandle(state.layout);
    var collectionLink = screenRoot.querySelector('[data-keycaps-collection-link]');
    if (collectionLink) collectionLink.setAttribute('href', '/collections/' + keycapsHandle);
    var grid = screenRoot.querySelector('[data-results-grid]');
    if (!grid) return;
    loadFilteredProducts(keycapsHandle, { inStockOnly: true }, 12, 3).then(function (res) {
      if (res.emptyCollection) {
        grid.innerHTML = emptyCollectionHtml(t('keycaps_results_title', { layout: LAYOUT_LABEL[state.layout] }));
        return;
      }
      if (res.products.length >= 3) {
        grid.innerHTML = res.products.map(function(p, i){ return productCardHtml(p, i, { maxBestSellers: 3 }); }).join('');
      } else if (res.fallback.length > 0) {
        grid.innerHTML = res.fallback.map(function(p, i){ return productCardHtml(p, i, { maxBestSellers: 3 }); }).join('');
      } else {
        grid.innerHTML = '<p class="ctc-tunnel__empty">' + t('no_keycaps_kit_html', { handle: keycapsHandle }) + '</p>';
      }
    });
  }

  function loadDoneRecap(titleHtml) {
    var titleEl = screenRoot.querySelector('.ctc-tunnel__done-title');
    if (titleEl) titleEl.innerHTML = titleHtml;
    loadKitDoneStep();
  }

  function loadKitDoneStep() {
    var cartContainer = screenRoot.querySelector('[data-done-cart]');
    if (!cartContainer) return;
    getCart().then(function (cart) {
      if (!cart.items || cart.items.length === 0) {
        cartContainer.innerHTML = '<p class="ctc-tunnel__empty">' + t('done_empty_cart') + '</p>';
        return;
      }
      var itemsHtml = cart.items.slice(0, 10).map(function (item) {
        var img = item.image || '';
        return (
          '<div class="ctc-done-line">' +
            (img ? '<span class="ctc-done-line__img"><img src="' + addImgWidth(img, 120) + '" alt=""></span>' : '<span class="ctc-done-line__img ctc-done-line__img--empty"></span>') +
            '<span class="ctc-done-line__body">' +
              '<span class="ctc-done-line__title">' + escapeHtml(item.product_title || item.title) + '</span>' +
              (item.variant_title && item.variant_title !== 'Default Title' ? '<span class="ctc-done-line__variant">' + escapeHtml(item.variant_title) + '</span>' : '') +
              '<span class="ctc-done-line__qty">' + t('done_qty', { qty: item.quantity }) + '</span>' +
            '</span>' +
            '<span class="ctc-done-line__price">' + formatPrice(item.final_line_price / 100) + '</span>' +
          '</div>'
        );
      }).join('');
      cartContainer.innerHTML =
        '<div class="ctc-done-list">' + itemsHtml + '</div>' +
        '<div class="ctc-done-total">' +
          '<span>' + t('done_total') + '</span>' +
          '<strong>' + formatPrice(cart.total_price / 100) + '</strong>' +
        '</div>';
    });

    // Cross-sell tapis acoustique : 1 produit best-seller par collection thématique
    // (argument validé par les claviéristes experts pour améliorer le son).
    var crosssell = screenRoot.querySelector('[data-done-crosssell]');
    var crosssellGrid = screenRoot.querySelector('[data-done-crosssell-grid]');
    if (crosssell && crosssellGrid) {
      getCart().then(function (cart) {
        if (!cart.items || cart.items.length === 0) return;
        var hasTapis = cart.items.some(function (it) {
          var title = (it.product_title || it.title || '').toLowerCase();
          return title.indexOf('tapis') > -1 || title.indexOf('deskmat') > -1 || title.indexOf('mousepad') > -1;
        });
        if (hasTapis) return; // pas la peine de re-proposer

        var tapisCollections = [
          { handle: 'tapis-de-souris-gamer-xxl', label: 'Gaming XXL' },
          { handle: 'tapis-de-souris-anime', label: 'Anime' },
          { handle: 'tapis-de-souris-jeux-video', label: 'Jeux vidéo' },
          { handle: 'tapis-de-souris-frieren', label: 'Frieren' },
          { handle: 'tapis-de-souris-pilote-aviateur', label: 'Pilote / Aviateur' },
          { handle: 'tapis-de-souris-dessin-anime', label: 'Dessin animé' }
        ];

        // Fetch 1 produit best-seller par collection en parallèle
        Promise.all(tapisCollections.map(function (col) {
          return fetchProducts(col.handle, { fetchLimit: 6 }).then(function (products) {
            var inStock = products.filter(productInStock);
            return inStock.length > 0 ? { col: col, product: inStock[0] } : null;
          }).catch(function () { return null; });
        })).then(function (results) {
          var validResults = results.filter(function (r) { return r !== null; });
          if (validResults.length === 0) return;
          crosssell.removeAttribute('hidden');
          crosssellGrid.innerHTML = validResults.map(function (r, idx) {
            return crosssellTapisCardHtml(r.product, r.col, idx);
          }).join('') +
          '<a href="/collections/tapis-de-souris-gamer-xxl" class="ctc-tunnel__done-crosssell-all">' + t('done_crosssell_all') + '</a>';
        });
      });
    }

    // Cross-sell câble USB-C : la gamme "simple" (24,99 EUR) est le best-seller absolu
    // de la collection. Câble coloré assorti = add-on d'impulsion en fin de parcours.
    var cableCross = screenRoot.querySelector('[data-done-cable-crosssell]');
    var cableGrid = screenRoot.querySelector('[data-done-cable-crosssell-grid]');
    if (cableCross && cableGrid) {
      getCart().then(function (cart) {
        var hasCable = cart.items && cart.items.some(function (it) {
          var title = (it.product_title || it.title || '').toLowerCase();
          return title.indexOf('câble') > -1 || title.indexOf('cable') > -1;
        });
        if (hasCable) return; // un câble est déjà au panier

        fetchProducts('cable-de-clavier-custom', { fetchLimit: 20 }).then(function (products) {
          var inStock = products.filter(productInStock);
          // Priorité à la gamme "simple" 24,99 EUR (best-seller). Fallback : best-sellers en stock.
          var simple = inStock.filter(function (p) {
            return (p.title || '').toLowerCase().indexOf('simple') > -1;
          });
          var pick = (simple.length >= 3 ? simple : inStock).slice(0, 4);
          if (pick.length === 0) return;
          cableCross.removeAttribute('hidden');
          cableGrid.innerHTML = pick.map(function (p, idx) {
            return crosssellCableCardHtml(p, idx);
          }).join('');
        });
      });
    }

    // Cross-sell outils / entretien : extracteur keycaps, lubrifiants, petits outils
    // de montage. Accessoires fortement associes a un achat clavier (insights expert :
    // l'extracteur est un cross-sell systematique recommande). Affiche sur les 3 ecrans
    // de fin (kit/keycaps/diy) si le panier n'en contient pas deja.
    var toolsCross = screenRoot.querySelector('[data-done-tools-crosssell]');
    var toolsGrid = screenRoot.querySelector('[data-done-tools-crosssell-grid]');
    if (toolsCross && toolsGrid) {
      getCart().then(function (cart) {
        var hasTool = cart.items && cart.items.some(function (it) {
          var title = (it.product_title || it.title || '').toLowerCase();
          return title.indexOf('extracteur') > -1 || title.indexOf('lubrifiant') > -1 ||
                 title.indexOf('krytox') > -1 || title.indexOf('tribosys') > -1;
        });
        if (hasTool) return;
        fetchProducts('outils', { fetchLimit: 12 }).then(function (products) {
          var inStock = products.filter(productInStock);
          var pick = inStock.slice(0, 4);
          if (pick.length === 0) return;
          toolsCross.removeAttribute('hidden');
          toolsGrid.innerHTML = pick.map(function (p, idx) {
            return crosssellTapisCardHtml(p, { label: '' }, idx);
          }).join('');
        });
      });
    }
  }

  function crosssellCableCardHtml(product, index) {
    // Tag couleur dérivé du dernier mot du titre (ex: "...Type-C Noir" -> "Noir").
    var titleParts = (product.title || '').trim().split(/\s+/);
    var colorLabel = titleParts.length > 0 ? titleParts[titleParts.length - 1] : '';
    return crosssellTapisCardHtml(product, { label: colorLabel }, index);
  }

  function crosssellTapisCardHtml(product, col, index) {
    var img = '';
    if (product.images && product.images.length > 0) img = product.images[0].src;
    else if (product.featured_image) img = product.featured_image;
    var variants = product.variants || [];
    var price = variants.length > 0 ? formatPrice(variants[0].price) : '';
    var singleVariant = variants.length === 1;
    var firstVariantId = variants[0] ? variants[0].id : '';
    var available = variants[0] ? variants[0].available !== false : true;
    return (
      '<div class="ctc-product ctc-product--tapis" data-product-handle="' + escapeHtml(product.handle) + '">' +
        (col && col.label ? '<span class="ctc-product__collection-tag">' + escapeHtml(col.label) + '</span>' : '') +
        '<button type="button" class="ctc-product__preview-trigger" data-action="open-preview" data-handle="' + escapeHtml(product.handle) + '" aria-label="' + escapeHtml(t('voir_produit')) + '">' +
          (img ? '<span class="ctc-product__img"><img loading="lazy" src="' + addImgWidth(img, 300) + '" alt="' + escapeHtml(product.title) + '"></span>' : '<span class="ctc-product__img ctc-product__img--empty"></span>') +
          '<span class="ctc-product__title">' + escapeHtml(product.title) + '</span>' +
          (price ? '<span class="ctc-product__price">' + price + '</span>' : '') +
        '</button>' +
        '<div class="ctc-product__actions">' +
          (singleVariant && available
            ? '<button type="button" class="ctc-product__add" data-action="quick-add" data-variant-id="' + firstVariantId + '" data-handle="' + escapeHtml(product.handle) + '" data-title="' + escapeHtml(product.title) + '">' + t('ajouter') + '</button>'
            : '<button type="button" class="ctc-product__add" data-action="open-preview" data-handle="' + escapeHtml(product.handle) + '">' + t('choisir') + '</button>'
          ) +
        '</div>' +
      '</div>'
    );
  }

  function openHelp(helpId) {
    var tpl = document.getElementById('ctc-help-' + helpId);
    if (!tpl) return;
    var overlay = document.createElement('div');
    overlay.className = 'ctc-modal';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML = '<div class="ctc-modal__inner"><button class="ctc-modal__close" type="button" aria-label="' + escapeHtml(t('expert_modal_close')) + '">&times;</button><div class="ctc-modal__body"></div></div>';
    overlay.querySelector('.ctc-modal__body').appendChild(tpl.content.cloneNode(true));
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';

    var ctcPrevFocus = document.activeElement;
    function close() {
      document.removeEventListener('keydown', onKeydown);
      overlay.remove();
      document.body.style.overflow = '';
      if (ctcPrevFocus && ctcPrevFocus.focus) ctcPrevFocus.focus();
    }
    overlay.ctcClose = close;
    function onKeydown(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') ctcTrapFocus(overlay, e);
    }
    overlay.querySelector('.ctc-modal__close').addEventListener('click', close);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });
    document.addEventListener('keydown', onKeydown);
    var ctcCloseBtn = overlay.querySelector('.ctc-modal__close');
    if (ctcCloseBtn) ctcCloseBtn.focus();
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    while (target && target !== document.body) {
      var action = target.getAttribute && target.getAttribute('data-action');
      if (action === 'open-preview') {
        e.preventDefault();
        openPreview(target.getAttribute('data-handle'), findComponentKeyForButton(target));
        return;
      }
      if (action === 'open-preview-quick') {
        e.preventDefault();
        openPreview(target.getAttribute('data-handle'), findComponentKeyForButton(target), { quick: true });
        return;
      }
      if (action === 'quick-add') {
        e.preventDefault();
        quickAdd(
          target.getAttribute('data-variant-id'),
          target.getAttribute('data-title'),
          target,
          findComponentKeyForButton(target)
        );
        return;
      }
      if (action === 'goto-diy-done') {
        e.preventDefault();
        renderScreen('diy-done');
        return;
      }
      if (action === 'open-expert') {
        e.preventDefault();
        openExpertModal();
        return;
      }
      target = target.parentNode;
    }
  });

  root.addEventListener('click', function (e) {
    var target = e.target;
    while (target && target !== root) {
      var action = target.getAttribute && target.getAttribute('data-action');
      if (action === 'select-persona') {
        state.persona = target.getAttribute('data-persona');
        track('select_persona', { persona: state.persona });
        nextScreen();
        return;
      }
      if (action === 'select-budget') {
        state.budget = target.getAttribute('data-budget');
        track('select_budget', { budget: state.budget });
        nextScreen();
        return;
      }
      if (action === 'pivot-to-kit') {
        // Depuis le DIY sans pieces dispo : on bascule sur le kit pret a monter
        // de la meme taille/layout, sans relancer le questionnaire.
        state.persona = 'kit';
        state.history = ['persona', 'size', 'layout'];
        renderScreen('results-kit');
        return;
      }
      if (action === 'select-size') {
        state.size = target.getAttribute('data-size');
        nextScreen();
        return;
      }
      if (action === 'select-layout') {
        state.layout = target.getAttribute('data-layout');
        nextScreen();
        return;
      }
      if (action === 'select-switch') {
        state.switchType = target.getAttribute('data-switch');
        nextScreen();
        return;
      }
      if (action === 'select-hotswap') {
        state.hotswap = target.getAttribute('data-hotswap');
        nextScreen();
        return;
      }
      if (action === 'back') {
        goBack();
        return;
      }
      if (action === 'restart') {
        restart();
        return;
      }
      if (action === 'close-inline') {
        closeInlineTunnel();
        return;
      }
      if (action === 'skip-step') {
        nextScreen();
        return;
      }
      // NB : 'open-expert' est volontairement gere uniquement par le listener delegue
      // sur document (plus haut) pour eviter une double ouverture de modale quand le
      // declencheur est a l'interieur de #ctc-tunnel (bouton header, CTA etats vides).
      if (action === 'open-help') {
        openHelp(target.getAttribute('data-help'));
        return;
      }
      if (action === 'edit-criterion') {
        editCriterion(target.getAttribute('data-criterion'));
        return;
      }
      if (action === 'filter-profile') {
        filterKeycapsByProfile(target.getAttribute('data-profile'), target);
        return;
      }
      if (action === 'filter-material') {
        filterKeycapsByMaterial(target.getAttribute('data-material'), target);
        return;
      }
      if (action === 'filter-switch-usage') {
        filterKitSwitchesByUsage(target.getAttribute('data-usage'), target);
        return;
      }
      target = target.parentNode;
    }
  });

  updateProgress();
  updateCartIndicator();
})();
